import React from "react";

export default function Footer() {
  return (
    <footer className="bg-blue-900 text-white py-10 mt-20">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <p className="mb-2">© 2025 BrightSmile Dental Clinic</p>
        <p className="text-sm opacity-80">
          Modern dental care you can trust.
        </p>
      </div>
    </footer>
  );
}
